module.exports = __webpack_public_path__ + "static/media/IMG-9592.835d3b2f.jpg";